import React from "react";
import { Box, Typography } from "@mui/material";

export default function Footer() {
  return (
    <Box sx={{ textAlign: "center", padding: 2, backgroundColor: "#f5f5f5" }}>
      <Typography>Email: support@fivestarchicken.com</Typography>
      <Typography>Contact: +91-9876543210</Typography>
    </Box>
  );
}